import { render, staticRenderFns } from "./HtmlReportIndividual.vue?vue&type=template&id=0bba66cd"
import script from "./HtmlReportIndividual.vue?vue&type=script&lang=js"
export * from "./HtmlReportIndividual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports